import React from 'react';
import Audio from '../audio/audio';
import { ImageRenderer as Image } from '../image/image-renderer.react';
import Link from '../link/link';
import PDFRenderer from '../pdf/pdf-renderer';
import Video from '../video/video';
import { EXTENSION_MEDIA_CONFIG, MEDIA_TYPE } from './constants';
export function getUrl(value: string) {
  try {
    return new URL(value);
  } catch (_) {
    // Not url
    return null;
  }
}
const DataComponent = ({
  value
}: {
  value: string | boolean | number;
}, options: {
  videoPlaybackSpeed?: number;
}) => {
  if (typeof value !== 'string') return value;
  const url = getUrl(value);
  if (!url) return value;
  // @ts-expect-error missing null check
  const extension = url.pathname.split('.').pop().toLowerCase();
  switch (EXTENSION_MEDIA_CONFIG[extension]) {
    case MEDIA_TYPE.VIDEO:
      return <Video src={value} videoPlaybackSpeed={options.videoPlaybackSpeed} />;
    case MEDIA_TYPE.IMAGE:
      return <Image src={value} />;
    case MEDIA_TYPE.AUDIO:
      return <Audio src={value} />;
    case MEDIA_TYPE.PDF:
      return <PDFRenderer src={value} />;
    // If no media type is identified, render the link
    default:
      return <Link href={value} target="_blank" rel="noopener noreferrer">
          {value}
        </Link>;
  }
};
export default DataComponent;